// removed by extract-text-webpack-plugin
module.exports = {"group":"_2qmkTrn5w2Ms0FuxXsg6B","spin":"_1Xb-g4orY4xM1752gMkM1z","slide-in":"_3PWgiGycvey38KCUq_vwFI","slideIn":"_3PWgiGycvey38KCUq_vwFI"};


//////////////////
// WEBPACK FOOTER
// ./src/vendor/react-store/components/Action/DropdownMenu/Group/styles.scss
// module id = 249
// module chunks = 8